import Fetcher from 'Scripts/common/fetcher';

export default class TicketPurchasesList {
	constructor(opts) {
		new Fetcher({
			element: $("#js-purchases-fetcher"),
		});
	}
}